module.exports = __webpack_public_path__ + "static/media/Electric_JEA.9b9dd8ef.svg";